import React from 'react'
import { FaAngleRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const Breadcrum = ({ heading, subheading }) => {
  return (
    <div className="flex justify-between items-center font-aptos-regular mb-10 font-light whitespace-nowrap">
      <p className="text-xl text-gray-700">{subheading}</p>
      <div className="flex items-center text-sm text-gray-700 space-x-2">
        <Link
          to="/dealdashboard"
          className="text-gray-700 relative after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 hover:after:w-full after:h-[2px] after:bg-[#ff7010] after:transition-all after:duration-300"
        >
          DSJ
        </Link>
        <FaAngleRight />

        {heading && (
          <>
            <span className="text-gray-600">{heading}</span>
          </>
        )}
      </div>
    </div>
  )
}

export default Breadcrum
